// extracted by mini-css-extract-plugin
module.exports = {"root":"Timeline_root__1lcI8","title":"Timeline_title__2i-eF","date":"Timeline_date__1QnxD"};